import ClickableMap from './ClickableMap';

export default ClickableMap;
